import { createContext } from "react";

export const ColyseusContext = createContext(null);
